"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredCheckbox = exports.isValidEmail = exports.isStartBeforeEnd = exports.required = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _is_before = _interopRequireDefault(require("date-fns/is_before"));

var required = function required(msg) {
  return function (value) {
    if ((0, _isEmpty["default"])(value)) throw new Error(msg);
    return value;
  };
};

exports.required = required;

var isStartBeforeEnd = function isStartBeforeEnd(msg) {
  return function (start, end) {
    if (start && end && !(0, _is_before["default"])(start, end)) throw new Error(msg);
  };
};
/**
 * @link https://emailregex.com/
 * The regex is based on General Email Regex (RFC 5322 Official Standard)
 */


exports.isStartBeforeEnd = isStartBeforeEnd;
var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

var isValidEmail = function isValidEmail(msg) {
  return function (value) {
    if (value === '') return value;
    if (regexEmail.test(String(value).toLowerCase())) return value;
    throw new Error(msg);
  };
};

exports.isValidEmail = isValidEmail;

var requiredCheckbox = function requiredCheckbox(msg) {
  return function (value) {
    if (!value) throw new Error(msg);
    return value;
  };
};

exports.requiredCheckbox = requiredCheckbox;